import { useContext as useReactContext, Context } from 'react';

const useContext = <T>(context: Context<T>) => {
    return useReactContext(context);
}
export default useContext;
